var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.741 3.208a2.264 2.264 0 012.05-1.67c1.172-.084 2.904-.163 5.271-.163 2.353 0 4.078.078 5.25.162a2.292 2.292 0 012.15 2.152c.085 1.17.163 2.896.163 5.248 0 2.368-.08 4.1-.164 5.271a2.265 2.265 0 01-1.67 2.05",
    stroke: "#000",
    strokeWidth: 0.917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.338 7.813a2.293 2.293 0 00-2.152-2.15c-1.17-.085-2.896-.163-5.248-.163-2.353 0-4.078.078-5.25.162a2.292 2.292 0 00-2.15 2.152c-.085 1.17-.163 2.896-.163 5.248 0 2.353.078 4.078.162 5.25a2.293 2.293 0 002.152 2.15c1.17.085 2.896.163 5.248.163 2.353 0 4.078-.078 5.25-.162a2.293 2.293 0 002.15-2.152c.085-1.17.163-2.896.163-5.248 0-2.353-.078-4.078-.162-5.25z",
    stroke: "#000",
    strokeWidth: 0.917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.012 14.083a3.208 3.208 0 10-3.697-.004c-1.144.427-2.056 1.241-2.52 2.255-.297.644.072 1.415.78 1.457l.02.002c1.186.058 2.374.085 3.562.082 1.516 0 2.692-.037 3.56-.082l.021-.002c.708-.043 1.078-.813.781-1.457-.463-1.01-1.37-1.822-2.507-2.25z",
    stroke: "#000",
    strokeWidth: 0.917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgDuplicate;